import { Stack, Typography } from '@chronosphereio/chrono-ui';
import { TooltipHeader } from '@/components';
import { formatValue, UnitOptions } from '@/core';
import { formatBucketBoundary, HeatmapCellInfo } from './heat-map-model';

export interface HeatMapTooltipContentProps {
  /**
   * Info about the hovered heatmap cell
   */
  info: HeatmapCellInfo;
  unit: UnitOptions;
}

/**
 * Transparent pane floating over the heatmap canvas, handling mouse interactivity
 * - render box around the hovered cell
 * - show a tooltip with info for the hovered cell
 */
export function HeatMapTooltipContent({ info, unit }: HeatMapTooltipContentProps) {
  return (
    <>
      <TooltipHeader startDate={new Date(info.timestamp)} enablePinning={false} />
      <Stack direction="column" paddingY={0.5}>
        <Stack direction="row" justifyContent="space-between" gap={1}>
          <Typography variant="body2">Bucket:</Typography>
          <Typography variant="body2">{`${formatBucketBoundary(info.bucket.lower, unit)} to ${formatBucketBoundary(info.bucket.upper, unit)}`}</Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between" gap={1}>
          <Typography variant="body2">Count:</Typography>
          <Typography variant="body2">
            {info.value === null ? '--' : formatValue(info.value, { kind: 'Decimal', abbreviate: true })}
          </Typography>
        </Stack>
      </Stack>
    </>
  );
}
